import {
	AppliancesNames,
	GlutenFreeIdentity as GlutenFreeIdentityType,
} from "../../constants/gluten-free";
import classNames from "classnames";
import { CircleXIcon } from "../atoms/CircleXIcon";
import { CircleCheckIcon } from "../atoms/CircleCheckIcon";
import { CircleQuestionMark } from "../atoms/CircleQuestionMark";
import { Inter } from "next/font/google";

const inter = Inter({ subsets: ["latin"] });

const Icons = {
	[GlutenFreeIdentityType.ENABLED]: CircleCheckIcon,
	[GlutenFreeIdentityType.NO]: CircleXIcon,
	[GlutenFreeIdentityType.UNKNOWN]: CircleQuestionMark,
	default: CircleQuestionMark,
};

export const GlutenFreeAppliancesList = ({ items = [] }) => {
	let elements = [];

	if (items.length > 0) {
		elements = [
			{
				text: AppliancesNames.OVEN,
				state: items.find((element) => element.text === AppliancesNames.OVEN)
					? GlutenFreeIdentityType.ENABLED
					: GlutenFreeIdentityType.NO,
			},
			{
				text: AppliancesNames.FRYER,
				state: items.find((element) => element.text === AppliancesNames.FRYER)
					? GlutenFreeIdentityType.ENABLED
					: GlutenFreeIdentityType.NO,
			},
			{
				text: AppliancesNames.STOVE,
				state: items.find((element) => element.text === AppliancesNames.STOVE)
					? GlutenFreeIdentityType.ENABLED
					: GlutenFreeIdentityType.NO,
			},
			{
				text: AppliancesNames.TOASTER,
				state: items.find((element) => element.text === AppliancesNames.TOASTER)
					? GlutenFreeIdentityType.ENABLED
					: GlutenFreeIdentityType.NO,
			},
		];
	}

	return (
		<div
			className={classNames({
				"flex items-center gap-2 md:flex-row flex-wrap": true,
			})}>
			{elements.map((item, index) => {
				const Icon = Icons[item.state] || Icons.default;

				return (
					<div
						key={item.text}
						className={classNames({
							"flex items-center gap-0.5 text-[11px]": true,
							"opacity-60": item.state === GlutenFreeIdentityType.NO,
						})}>
						<Icon
							size={12}
							weight="fill"
						/>
						<h1
							key={index}
							className={classNames(inter.className, "text-sky-950")}>
							{item.text}
						</h1>
					</div>
				);
			})}
		</div>
	);
};
